import { HTTP_METHODS } from '@studio/constants/axios';
import { MEDIA_METADATA_API_V1 } from '@studio/constants/env-variables';

export const root = {
  [HTTP_METHODS.POST]: {
    url: `${MEDIA_METADATA_API_V1}/customers/@customerId/media/@mediaId/autocrop`,
    request: {} as { endMillis: number; startMillis: number },
    params: {} as { mediaId: string },
    method: HTTP_METHODS.POST,
  },
};
